import React from 'react';
import { Boxed } from "../../components/Boxed.components"
import { LabelText } from "../../components/Text.components";
import { formatCurrency, formatDate } from "../../utils/utils";
import { Theme } from '../../utils/theme';


export const  FormDisplay = (props) => { 
    const { applicationData } = props;

    let renderDetails = applicationData?.requestDetails?.map((item, index) => { 
        switch(item?.dataType){ 
            case 'TextInput':
            case 'String':
                return <LabelText key={index} label={item?.label} value={item.value} />;
            
            case 'Date':
                return <LabelText key={index} label={item?.label} value={item.value ? formatDate(item.value) : '--'} />;
            case 'NumberInput':
            case 'Number': 
                return <LabelText key={index} label={item?.label} value={item.value ? formatCurrency(item.value) : '--'} />;
            default: 
                return null
        }
    })

    console.log({ applicationData, requestDetails : applicationData?.requestDetails})

    return ( 
        <Boxed pad="5px 0">
            <Boxed pad="20px" background={Theme.TertiaryDark} borderRadius={Theme.PrimaryRadius}>
            {renderDetails}
            </Boxed>
        </Boxed>
    )
}